"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _mimeType = _interopRequireDefault(require("../utils/mime-type"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Item = /*#__PURE__*/function () {
  /**
   *
   */
  function Item() {
    _classCallCheck(this, Item);

    /**
     * @type {boolean}
     */
    this.boost = false;
    /**
     * @type {string[]}
     */

    this.contentTypes = [];
    /**
     * @type {string}
     */

    this.date = '';
    /**
     * @type {boolean}
     */

    this.downloadDirectly = false;
    /**
     * @type {string[]}
     */

    this.filters = [];
    /**
     * @type {boolean}
     */

    this.forceLock = false;
    /**
     * @type {boolean}
     */

    this.generateThumbnail = true;
    /**
     * @type {boolean}
     */

    this.hidden = false;
    /**
     * @type {string}
     */

    this.id = '';
    /**
     * @type {string}
     */

    this.image = '';
    /**
     * @type {boolean}
     */

    this.locked = false;
    /**
     * @type {string}
     */

    this.mimeType = '';
    /**
     * @type {string}
     */

    this.name = '';
    /**
     * @type {string}
     */

    this.text = '';
    /**
     * @type {string}
     */

    this.url = '';
  }

  _createClass(Item, [{
    key: "shouldDownload",
    value: function shouldDownload() {
      return this.locked || this.downloadDirectly || this.mimeType === _mimeType["default"].EXTERNAL;
    }
  }], [{
    key: "fromEndpoint",
    value: function fromEndpoint(data) {
      var item = new Item();
      item.boost = data.boost;
      item.contentTypes = data.contentTypes;
      item.date = data.date;
      item.downloadDirectly = data.downloadDirectly;
      item.filters = data.filters;
      item.forceLock = data.forceLock;
      item.generateThumbnail = data.generateThumbnail;
      item.hidden = data.hidden;
      item.id = data.id;
      item.image = data.image;
      item.locked = data.locked;
      item.mimeType = data.mimeType;
      item.name = data.name;
      item.text = data.text;
      item.url = data.url;
      return item;
    }
  }]);

  return Item;
}();

var _default = Item;
exports["default"] = _default;